<video-preview-player [layoutCfg]="producerOptions.onStageLayout" [bgImages]="bgImages" [isPreview]="false" [isProducer]="isProducer" [noStreamText]="helperText" [producerOptions]="producerOptions">
	<div [ngClass]="styles.previewPlayerHeader">
		<span flex="fill">
			{{ (broadcasting ? 'Event_Producer_OnstageBroadcasting' : 'Event_Producer_OnstageNotBroadcasting') | translate }}
		</span>

		<audio-presenters [layout]="producerOptions.onStageLayout">
		</audio-presenters>
	</div>
</video-preview-player>
